import React from "react";
import HomeAbout from "../../components/home/HomeAbout";
import { Image } from "antd";
import Team from "../../components/home/Team";
import { API_COMMON } from "../../utils/api";

const AboutUs = () => {
  return (
    <div className="w-full bg-white dark:bg-slate-900 pt-10">
      <h2 className="font-bold text-5xl text-slate-700 dark:text-white text-center">
        Textaj Sourcing Internatioal Limited
      </h2>
      <h2 className="font-bold text-sm text-slate-900 dark:text-white text-center uppercase mt-2">
        Sustainable Apparel Solution
      </h2>


      {/* Managing Director's Message */}
      <section className="w-full bg-slate-50 dark:bg-slate-800/50 py-12 md:py-16 lg:py-20 mt-16">
        <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-bold text-3xl sm:text-4xl text-slate-700 dark:text-white text-center mb-10 md:mb-14">
            Managing Director&apos;s Message
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            <div className="lg:col-span-4 order-2 lg:order-1 flex justify-center lg:justify-start">
              <div className="w-full max-w-sm aspect-[3/4] rounded-xl overflow-hidden shadow-lg ring-1 ring-slate-200 dark:ring-slate-700 bg-slate-200 dark:bg-slate-700">
                <Image
                  preview={false}
                  src={`/assets/images/chairman.jpeg`}
                  alt="Mosiur Rahaman - Managing Director, Textaj Sourcing International Ltd."
                  className="w-full h-full object-cover"
                  // fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 267' fill='%2394a3b8'%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-size='14' fill='%2364748b'%3EPhoto%3C/text%3E%3C/svg%3E"
                />
              </div>
            </div>
            <div className="lg:col-span-8 order-1 lg:order-2">
              <div className="prose prose-slate dark:prose-invert max-w-none">
                <p className="text-slate-600 dark:text-slate-300 text-sm sm:text-base mb-4">
                  <span className="font-semibold text-slate-800 dark:text-white">
                    Textaj Sourcing International Ltd.
                  </span>
                </p>
                <p className="text-slate-600 dark:text-slate-300 text-sm sm:text-base leading-relaxed mb-4">
                  I am pleased to welcome you to Textaj Sourcing International.
                </p>
                <p className="text-slate-600 dark:text-slate-300 text-sm sm:text-base leading-relaxed mb-4">
                  My name is Mosiur Rahaman, and I am the Managing Director of
                  this organization. I am a Textile Engineer by profession, having
                  completed both my graduate and postgraduate degrees in Textile
                  Engineering and Textile Business Management. Over the past 12
                  years, I have gained extensive experience working across
                  textile trading as well as manufacturing units. I have also had
                  the privilege of working with prominent fashion brands across
                  the USA, UK, Denmark, France, Belgium, Norway, Poland, and
                  Portugal, which has given me strong insight into global market
                  expectations, quality standards, and consumer trends.
                </p>
                <p className="text-slate-600 dark:text-slate-300 text-sm sm:text-base leading-relaxed mb-4">
                  Textaj Sourcing International was established in 2024 with a
                  clear vision — to be a reliable, innovative, and globally
                  trusted textile sourcing partner. Our mission is to bridge
                  international buyers with the best manufacturing capabilities,
                  ensuring transparency, consistency, and long-term value for
                  our clients.
                </p>
                <p className="text-slate-600 dark:text-slate-300 text-sm sm:text-base leading-relaxed mb-4">
                  As Managing Director, my personal commitment is to ensure that
                  Textaj Sourcing International remains a company built on
                  trust, professionalism, integrity, and long-term partnerships.
                  We do not measure success only by sales, but by the confidence
                  and satisfaction of our clients.
                </p>
                <p className="text-slate-600 dark:text-slate-300 text-sm sm:text-base leading-relaxed mb-4">
                  I sincerely thank you for your interest in Textaj Sourcing
                  International. We look forward to working with you and becoming
                  your trusted textile sourcing partner.
                </p>
                <div className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-600">
                  <p className="font-semibold text-slate-800 dark:text-white text-base mb-1">
                    Mosiur Rahaman
                  </p>
                  <p className="text-slate-600 dark:text-slate-300 text-sm mb-3">
                    Managing Director
                  </p>
                  <p className="text-slate-600 dark:text-slate-300 text-sm">
                    <a
                      href="mailto:mosiur@textaj.com"
                      className="text-primary hover:underline"
                    >
                      Email: mosiur@textaj.com
                    </a>
                  </p>
                  <p className="text-slate-600 dark:text-slate-300 text-sm">
                    <a
                      href="tel:+8801618709971"
                      className="text-primary hover:underline"
                    >
                      Phone: +8801618709971
                    </a>
                  </p>
                  <p className="text-slate-600 dark:text-slate-300 text-sm mt-2 font-medium">
                    Textaj Sourcing International Ltd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className=" w-full md:w-2/3 container mx-auto mb-16">
        <div className="grid grid-cols-1 xl:grid-cols-1 gap-10 mt-16">
          <div className="flex flex-col items-start gap-5">
            {/* <h2 className="font-bold text-5xl text-slate-700 dark:text-white text-left">
              Textaj Sourcing Internatioal Limited
            </h2>
            <h2 className="font-bold text-sm text-slate-900 dark:text-white text-center uppercase -mt-2">
              Sustainable Apparel Solution
            </h2> */}
            <div className="mt-5 flex flex-col gap-5">
              <p className="text-base">
                <span className="font-bold text-xl">Overview:</span>
                &nbsp;Founded in 2020, Textaj Sourcing Internatioal Limited is a
                premier apparel sourcing and manufacturing agent based in
                Bangladesh. Specializing in sustainable fashion, the company has
                rapidly established itself as a reliable partner for clients
                around the globe, including Denmark, France, Italy, the USA, the
                UK, Australia, and various Scandinavian countries.
              </p>
              <p className="text-base">
                <span className="font-bold text-xl">
                  Commitment to Sustainability:
                </span>
                &nbsp; Textaj Sourcing Internatioal Limited prides itself on offering
                eco-friendly products that do not compromise on style. The
                company&#39;s product range includes apparel made from BCI
                (Better Cotton Initiative) cotton, organic materials, and
                recycled fibers. This commitment to sustainability ensures that
                each piece of clothing is not only fashionable but also
                environmentally responsible.
              </p>
              <p className="text-base">
                <span className="font-bold text-xl">Mission: </span>&nbsp;Textaj
                Sourcing International’s mission is to provide sustainable and
                eco-friendly products that meet the fashion needs of their
                clients while protecting the environment. This dual focus on
                style and sustainability sets the company apart in the
                competitive of apparel manufacturing.
              </p>
            </div>
          </div>
          {/* <div className="w-full flex items-start justify-center">
            <Image
              preview={false}
              src="/assets/images/common/16.jpg"
              alt="company image"
              height="80%"
            />
          </div> */}
        </div>
      </div>

      <Team />
    </div>
  );
};

export default AboutUs;
